export default __webpack_public_path__ + "static/media/default.b8069541672e4bd53a732f8ecb3a18d8.svg";